"use client";

import { usePathname } from "next/navigation";
import type { HTMLAttributes } from "react";

/** PolicyScreen supplies its own main landmark; other routes keep the app shell's. */
export default function MainContent({ children, ...props }: HTMLAttributes<HTMLElement>) {
  const pathname = usePathname();
  const Element = pathname?.startsWith("/policies/") ? "div" : "main";
  return <Element {...props}>{children}</Element>;
}
